import { useState } from 'react';
import { FiArrowLeft as ArrowLeft } from 'react-icons/fi';
import { ui } from '../constants';
import ToolsComparisonModal from './ToolsComparisonModal';

function ToolsComparisonCard() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section className="tools-comparison-card rounded-4">
        <div>
          <span className="eyebrow fs--2">{ui.comparisonCard.eyebrow}</span>
          <h3 className="text-1000">{ui.comparisonCard.title}</h3>
        </div>
        <div className="tools-comparison-actions">
          <button type="button" className="rounded-3 text-900 fs--2" onClick={() => setModalOpen(true)}>
            {ui.comparisonCard.button}
            <ArrowLeft size={17} />
          </button>
        </div>
      </section>
      <ToolsComparisonModal
        show={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}

export default ToolsComparisonCard;
